import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combines class names using clsx and merges Tailwind classes intelligently
 * This is the standard AlignUI utility for class name composition
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
